<template>
  <template v-if="heading">
    <h2
      v-if="!isSidebar"
      class="
        typo-h-2 mb-2 max-w-title whitespace-pre-wrap
        md:mb-3
      "

      v-html="heading"
    />

    <h3
      v-else
      class="
        typo-h-3 mb-2 max-w-title whitespace-pre-wrap
        md:mb-3
      "

      v-html="heading"
    />
  </template>

  <div
    v-if="text"
    class="
      wysiwyg mb-4
      md:mb-6
    "
    v-html="text"
  />
</template>

<script setup lang="ts">
defineProps({
  heading: {
    type: String, default: '',
  },
  text: {
    type: String, default: '',
  },
})

const isSidebar = inject<boolean>('isSidebar', false)
</script>
